"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[475],{

/***/ 14036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k1": function() { return /* binding */ useHubspotForm; },
/* harmony export */   "l0": function() { return /* binding */ HubspotProvider; }
/* harmony export */ });
/* unused harmony exports HubSpotFormLocale, useHubspotContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Locales supported by HubSpot forms
 */
var HubSpotFormLocale;
(function (HubSpotFormLocale) {
    /**
     * English
     */
    HubSpotFormLocale["ENGLISH"] = "en";
    /**
     * Danish
     */
    HubSpotFormLocale["DANISH"] = "da";
    /**
     * German
     */
    HubSpotFormLocale["GERMAN"] = "de";
    /**
     * Spanish (Spain)
     */
    HubSpotFormLocale["SPANISH"] = "es";
    /**
     * Spanish (Mexico)
     */
    HubSpotFormLocale["SPANISH_MEXICO"] = "es-mx";
    /**
     * Finnish
     */
    HubSpotFormLocale["FINNISH"] = "fi";
    /**
     * French
     */
    HubSpotFormLocale["FRENCH"] = "fr";
    /**
     * Italian
     */
    HubSpotFormLocale["ITALIAN"] = "it";
    /**
     * Japanese
     */
    HubSpotFormLocale["JAPANESE"] = "ja";
    /**
     * Dutch
     */
    HubSpotFormLocale["DUTCH"] = "nl";
    /**
     * Polish
     */
    HubSpotFormLocale["POLISH"] = "pl";
    /**
     * Portuguese
     */
    HubSpotFormLocale["PORTUGUESE"] = "pt-br";
    /**
     * Swedish
     */
    HubSpotFormLocale["SWEDISH"] = "sv";
    /**
     * Chinese
     */
    HubSpotFormLocale["CHINESE"] = "zh-cn";
    /**
     * Chinese (Hong Kong)
     */
    HubSpotFormLocale["CHINESE_HONG_KONG"] = "zh-hk";
})(HubSpotFormLocale || (HubSpotFormLocale = {}));

// Hook
var cachedScripts = [];
function useScript(src, async, addToHead) {
    if (async === void 0) { async = true; }
    if (addToHead === void 0) { addToHead = false; }
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loaded = _a[0], setLoaded = _a[1];
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), error = _b[0], setError = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        // If cachedScripts array already includes src that means another instance ...
        // ... of this hook already loaded this script, so no need to load again.
        if (cachedScripts.includes(src)) {
            setLoaded(true);
            setError(false);
        }
        else {
            cachedScripts.push(src);
            // Create script
            var script_1 = document.createElement('script');
            script_1.src = src;
            script_1.async = async;
            // Script event listener callbacks for load and error
            var onScriptLoad_1 = function () {
                setLoaded(true);
                setError(false);
            };
            var onScriptError_1 = function () {
                // Remove from cachedScripts we can try loading again
                var index = cachedScripts.indexOf(src);
                if (index >= 0) {
                    cachedScripts.splice(index, 1);
                }
                script_1.remove();
                setLoaded(true);
                setError(true);
            };
            script_1.addEventListener('load', onScriptLoad_1);
            script_1.addEventListener('error', onScriptError_1);
            // Add script to document head if required, otherwise to the body
            addToHead
                ? document.head.appendChild(script_1)
                : document.body.appendChild(script_1);
            // Remove event listeners on cleanup
            return function () {
                script_1.removeEventListener('load', onScriptLoad_1);
                script_1.removeEventListener('error', onScriptError_1);
            };
        }
    }, [src]); // Only re-run effect if script src changes
    return [loaded, error];
}

var HubspotContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    loaded: false,
    error: false
});
var useHubspotContext = function () { return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HubspotContext); };
var HubspotProvider = function (_a) {
    var async = _a.async, addToHead = _a.addToHead, children = _a.children;
    // Attach hubspot script to the document
    var _b = useScript('https://js.hsforms.net/forms/v2.js', async, addToHead), loaded = _b[0], error = _b[1];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(HubspotContext.Provider, { value: { loaded: loaded, error: error } }, children));
};

var useHubspotForm = function (props) {
    var _a = useHubspotContext(), loaded = _a.loaded, error = _a.error;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), formCreated = _b[0], setFormCreated = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (typeof window !== 'undefined' && window) {
            var windowWithHubspot = window;
            if (loaded && windowWithHubspot.hbspt && !formCreated) {
                windowWithHubspot.hbspt.forms.create(props);
                setFormCreated(true);
            }
        }
    }, [loaded, formCreated, setFormCreated]);
    return { loaded: loaded, formCreated: formCreated, error: error };
};




/***/ }),

/***/ 33218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getProfileApi; }
/* harmony export */ });
/* harmony import */ var src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49394);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91695);


var getProfileApi = function getProfileApi(userAuthId) {
  return src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .USERS_SERVICE_URI */ .Qi, "/user"), {
    headers: {
      Authorization: userAuthId
    }
  });
};

/***/ }),

/***/ 40475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(50029);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16835);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(53918);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(18132);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14416);
/* harmony import */ var _aaronhayes_react_use_hubspot_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14036);
/* harmony import */ var server_api_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33218);
/* harmony import */ var src_redux_common_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28441);
/* harmony import */ var src_redux_user__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36970);
/* harmony import */ var src_utils_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4848);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20213);
/* harmony import */ var src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(60316);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);




















var HeaderContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return __webpack_require__.e(/* import() */ 5121).then(__webpack_require__.bind(__webpack_require__, 55121));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(55121)];
    }
  }
});
var ResumeOfferModalContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(7855), __webpack_require__.e(7120), __webpack_require__.e(4066)]).then(__webpack_require__.bind(__webpack_require__, 94066));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(94066)];
    }
  }
});
var NewsletterContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(804), __webpack_require__.e(1521), __webpack_require__.e(1590), __webpack_require__.e(7855), __webpack_require__.e(7120), __webpack_require__.e(2547), __webpack_require__.e(814)]).then(__webpack_require__.bind(__webpack_require__, 70814));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(70814)];
    }
  }
});
var ContactContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6741), __webpack_require__.e(804), __webpack_require__.e(1521), __webpack_require__.e(2223), __webpack_require__.e(7855), __webpack_require__.e(7120), __webpack_require__.e(2547), __webpack_require__.e(835)]).then(__webpack_require__.bind(__webpack_require__, 835));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(835)];
    }
  }
});
var FooterContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return __webpack_require__.e(/* import() */ 9222).then(__webpack_require__.bind(__webpack_require__, 33302));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(33302)];
    }
  }
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div.withConfig({
  displayName: "Layout__Wrapper",
  componentId: "sc-50gxze-0"
})(["text-align:center;background-color:#fcfbfe;@media (max-width:768px){&{margin-top:56px;}}"]);

var Layout = function Layout(_ref) {
  var isFullScreen = _ref.isFullScreen,
      hasContactSection = _ref.hasContactSection,
      hasContactAction = _ref.hasContactAction,
      hasModalResume = _ref.hasModalResume,
      children = _ref.children;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_15__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();

  var _useTracking = (0,src_utils_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useTracking */ .rS)(),
      _useTracking2 = (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_useTracking, 1),
      setTracking = _useTracking2[0];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var isLoading = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (state) {
    return state.common.isLoading;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var cookies = (0,cookies_next__WEBPACK_IMPORTED_MODULE_4__.getCookies)();

    function fetchUserProfile(_x) {
      return _fetchUserProfile.apply(this, arguments);
    }

    function _fetchUserProfile() {
      _fetchUserProfile = (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userAuthId) {
        var profile;
        return _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0,server_api_user__WEBPACK_IMPORTED_MODULE_7__/* .getProfileApi */ .t)(userAuthId);

              case 3:
                profile = _context.sent;

                if (profile && profile.data && profile.data.id) {
                  dispatch((0,src_redux_user__WEBPACK_IMPORTED_MODULE_9__/* .getProfileSuccess */ .Ej)({
                    profile: profile.data
                  }));
                } else {
                  dispatch((0,src_redux_user__WEBPACK_IMPORTED_MODULE_9__/* .getProfileFailure */ .Pz)({
                    errors: profile.errors || 'unknown'
                  }));
                }

                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                dispatch((0,src_redux_user__WEBPACK_IMPORTED_MODULE_9__/* .getProfileFailure */ .Pz)({
                  errors: _context.t0.errors || 'unknown'
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));
      return _fetchUserProfile.apply(this, arguments);
    }

    if (cookies.userAuthId) {
      fetchUserProfile(cookies.userAuthId);
    }

    setTracking();
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    window.addEventListener('click', documentClickHandler, {
      once: true
    });
    dispatch((0,src_redux_common_actions__WEBPACK_IMPORTED_MODULE_8__/* .toggleLoader */ .m)(false)); // router.events.on('routeChangeStart', () => dispatch(toggleLoader(true)));

    router.events.on('routeChangeComplete', function () {
      return dispatch((0,src_redux_common_actions__WEBPACK_IMPORTED_MODULE_8__/* .toggleLoader */ .m)(false));
    });
    router.events.on('routeChangeError', function () {
      return dispatch((0,src_redux_common_actions__WEBPACK_IMPORTED_MODULE_8__/* .toggleLoader */ .m)(false));
    });
    return function () {
      window.removeEventListener('click', documentClickHandler);
    };
  }, [router]);

  var documentClickHandler = function documentClickHandler(event) {
    if (event.target.nodeName === 'A') {
      dispatch((0,src_redux_common_actions__WEBPACK_IMPORTED_MODULE_8__/* .toggleLoader */ .m)(true));
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_11__/* .MetaTags */ .NR, {
      meta: t('common:meta', {
        returnObjects: true
      })
    }), !isFullScreen && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(HeaderContainer, {
      title: t('common:header.imageTitle')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_11__/* .Spinner */ .$j, {
      isVisible: isLoading
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_12__/* .Logo */ .TR, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(_aaronhayes_react_use_hubspot_form__WEBPACK_IMPORTED_MODULE_6__/* .HubspotProvider */ .l0, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(Wrapper, {
        children: children
      }), !isFullScreen && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
        children: [hasContactSection && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(ContactContainer, {
          title: t('common:contact.title'),
          description: t('common:contact.description'),
          action: hasContactAction ? t('common:contact.action') : null
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(NewsletterContainer, {
          title: t('common:newsletter.title'),
          description: t('common:newsletter.description')
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(FooterContainer, {}), hasModalResume && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(ResumeOfferModalContainer, {})]
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Layout);

/***/ }),

/***/ 60316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aG": function() { return /* reexport */ StructuredData_Breadcrumb; },
  "By": function() { return /* reexport */ StructuredData_Faq; },
  "TR": function() { return /* reexport */ StructuredData_Logo; },
  "dc": function() { return /* reexport */ StructuredData_NltOffer; },
  "_6": function() { return /* reexport */ StructuredData_OfferList; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/containers/data/brands.json
var brands = __webpack_require__(11669);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/NltOffer.tsx





var NltOffer = function NltOffer(_ref) {
  var offerData = _ref.offerData;
  var data = {
    "@context": "https://schema.org/",
    "@type": "Vehicle",
    "name": "".concat(offerData.vehicle.name, " - Noleggio a Lungo Termine"),
    "image": offerData.images.map(function (image) {
      return image.src;
    }),
    "description": "".concat(offerData.vehicle.name, " a ").concat(offerData.monthlyRate, "\u20AC al mese! Con CarPlanner hai manutenzione, assicurazione, bollo, tassa di propriet\xE0 a molti altri servizi, inclusi in un unico canone mensile."),
    "sku": offerData.code,
    "mpn": offerData.id,
    "fuelType": offerData.vehicle.engine.fuel,
    "brand": {
      "@type": "Brand",
      "name": offerData.vehicle.brand,
      "logo": brands.find(function (brand) {
        return brand.href === offerData.vehicle.brandCode;
      }).image
    },
    "offers": {
      "@type": "Offer",
      "url": "https://www.carplanner.com/noleggio-a-lungo-termine/".concat(offerData.vehicle.brandCode, "/").concat(offerData.vehicle.modelCode, "/").concat(offerData.code),
      "priceCurrency": 'EUR',
      "price": offerData.monthlyRate,
      "itemCondition": 'https://schema.org/NewCondition',
      "availability": 'https://schema.org/LimitedAvailability',
      "seller": {
        '@type': 'Organization',
        "name": "CarPlanner",
        "url": "https://www.carplanner.com/",
        "logo": "https://static1.carplanner.com/logos/carplanner.svg"
      }
    }
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataNltOffer",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_NltOffer = (NltOffer);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Logo.tsx




var Logo = function Logo() {
  var data = {
    "@context": "https://schema.org/",
    "@type": "Organization",
    "name": "Noleggio a Lungo Termine",
    "url": "https://www.carplanner.com/",
    "logo": "https://static1.carplanner.com/logos/carplanner.svg"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataLogo",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Logo = (Logo);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./server/api/nlt.ts
var nlt = __webpack_require__(27449);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Faq.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var Faq = function Faq() {
  var _useState = (0,react.useState)([]),
      faqSingleItems = _useState[0],
      setFaqSingleItems = _useState[1];

  (0,react.useEffect)(function () {
    function getFaqs() {
      return _getFaqs.apply(this, arguments);
    }

    function _getFaqs() {
      _getFaqs = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var faqs;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,nlt/* getFaqAutoCompleteItems */.eF)();

              case 2:
                faqs = _context.sent;
                setFaqSingleItems(faqs.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getFaqs.apply(this, arguments);
    }

    if (!faqSingleItems.length) {
      getFaqs();
    }
  });
  var faqItems = {};
  faqSingleItems.forEach(function (faqItem) {
    faqItems[faqItem.uri] = faqItems[faqItem.uri] || [];
    faqItems[faqItem.uri].push(_objectSpread({}, faqItem));
  });
  var data = {
    "@context": "https://schema.org/",
    "@type": "FAQPage",
    "mainEntity": Object.keys(faqItems).map(function (faqUri) {
      return {
        "@type": "Question",
        "url": "https://www.carplanner.com/noleggio-a-lungo-termine/faq/".concat(faqUri),
        "name": faqItems[faqUri][0].title,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faqItems[faqUri].map(function (faqItem) {
            return "<p><strong>".concat(faqItem.q || '', "</strong> ").concat(faqItem.a || '', "</p>");
          }).join('')
        }
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataFaq",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Faq = (Faq);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/Breadcrumb.tsx




var Breadcrumb = function Breadcrumb(_ref) {
  var breadcrumbData = _ref.breadcrumbData;
  var data = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbData.map(function (crumbItem, idx) {
      return {
        "@type": "ListItem",
        "position": idx + 1,
        "name": crumbItem.title,
        "item": "https://carplanner.com".concat(crumbItem.href)
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataBreadcrumb",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_Breadcrumb = (Breadcrumb);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/OfferList.tsx




var OfferList = function OfferList(_ref) {
  var items = _ref.items;
  var data = {
    "@context": "https://schema.org/",
    "@type": "ItemList",
    "numberOfItems": items.length,
    "itemListElement": items.map(function (item, idx) {
      return {
        "@type": "ListItem",
        "position": idx,
        "url": item
      };
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataOfferList",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ var StructuredData_OfferList = (OfferList);
;// CONCATENATED MODULE: ./src/components/common/StructuredData/index.ts






/***/ }),

/***/ 20213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Do": function() { return /* reexport */ Offers_FilterSwitch; },
  "dB": function() { return /* reexport */ Offers_FilterTag; },
  "TY": function() { return /* reexport */ Offers_FilterTagCheckbox; },
  "Sz": function() { return /* reexport */ Offers_FilterTagImage; },
  "Fb": function() { return /* reexport */ common_Head; },
  "Mu": function() { return /* reexport */ LinkRel; },
  "NR": function() { return /* reexport */ common_MetaTags; },
  "$j": function() { return /* reexport */ common_Spinner; }
});

// UNUSED EXPORTS: SpaceL, SpaceXS, SpaceXXL, SpaceXXL4, SpaceXXL5, SpaceXXL6, Title

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(53918);
;// CONCATENATED MODULE: ./src/components/common/Title.tsx

var Title = styled_components_browser_esm["default"].h2.withConfig({
  displayName: "Title",
  componentId: "sc-ajob4w-0"
})(["margin-top:25px;margin-bottom:15px;font-size:30px;"]);
/* harmony default export */ var common_Title = ((/* unused pure expression or super */ null && (Title)));
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
// EXTERNAL MODULE: ./src/containers/data/slider.json
var slider = __webpack_require__(34755);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/common/Head.tsx








var Head = function Head(_ref) {
  var title = _ref.title;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: slider/* image */.BH
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: slider/* boxes.0.image */.qk[0].image
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "preload",
      as: "image",
      href: slider/* boxes.1.image */.qk[1].image
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "Cookiebot",
      src: "https://consent.cookiebot.com/uc.js",
      "data-cbid": "93243ddb-bf78-4f8b-b7bc-52a29e9f53e5",
      "data-blockingmode": "auto",
      type: "text/javascript",
      async: true
    })]
  });
};

/* harmony default export */ var common_Head = (Head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
;// CONCATENATED MODULE: ./src/components/common/MetaTags.tsx





var MetaTags = function MetaTags(_ref) {
  var meta = _ref.meta;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: meta.length > 0 && meta.map(function (tag) {
      if (tag.name) {
        var _tag$content;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          name: tag.name,
          content: tag.override && tag.override.trim() !== '' ? tag.override : (_tag$content = tag.content) !== null && _tag$content !== void 0 ? _tag$content : ''
        }, tag.name);
      }

      if (tag.property) {
        var _tag$content2;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: tag.property,
          content: tag.override && tag.override.trim() !== '' ? tag.override : (_tag$content2 = tag.content) !== null && _tag$content2 !== void 0 ? _tag$content2 : ''
        }, tag.property);
      }

      return null;
    })
  });
};

/* harmony default export */ var common_MetaTags = (MetaTags);
var LinkRel = function LinkRel(_ref2) {
  var rel = _ref2.rel,
      href = _ref2.href,
      crossOrigin = _ref2.crossOrigin,
      type = _ref2.type,
      as = _ref2.as;
  var url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    var _href$split = href.split('?');

    var _href$split2 = (0,slicedToArray/* default */.Z)(_href$split, 1);

    url = _href$split2[0];
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(83292);
;// CONCATENATED MODULE: ./src/components/common/Spinner.tsx





var LogoSpinner = function LogoSpinner() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 35",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#2EC58D",
          d: "M40.5,19c-3.6-3.4-9.2-3.2-12.6,0.4l-2,2.2l-0.9,1v0l-0.7,0.8l-5.1,5.5c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c-1.3,1.3-3.1,1.7-4.8,1.2c0,0,0,0,0,0c-0.1,0-0.3-0.1-0.4-0.1c0,0,0,0,0,0c-0.1,0-0.2-0.1-0.4-0.2c0,0,0,0,0,0 c-0.1-0.1-0.2-0.1-0.3-0.2c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0 c0,0-0.1-0.1-0.1-0.1l0,0c-1.9-1.8-2-4.9-0.2-6.8c1.8-1.9,4.9-2,6.8-0.2c0.6,0.5,1,1.2,1.2,1.8l3-3.2c-0.4-0.6-0.8-1.2-1.4-1.7 c-3.6-3.4-9.2-3.2-12.6,0.4c-2.9,3.1-3.2,7.6-1,11c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2 c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2C8.9,31.3,9,31.4,9,31.4c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.2 c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.2 c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c3.6,2.8,8.8,2.5,12-0.9l2-2.1c0,0,0.9-1,0.9-1l0.7-0.8l5.1-5.6c0,0,0,0,0,0 c1.8-1.9,4.9-2,6.8-0.2c1.9,1.8,2,4.9,0.2,6.8c-1.8,1.9-4.9,2-6.8,0.2c-0.6-0.5-1-1.2-1.2-1.8l-3,3.2c0.4,0.6,0.8,1.2,1.4,1.7 c3.6,3.4,9.2,3.2,12.6-0.4C44.3,28,44.1,22.3,40.5,19z"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#2EC58D",
          d: "M45.8,7.7C42.3,2.6,36.7,0,29.2,0C22.8,0,15.6,3,9.5,8.3C3.6,13.4,0,19.7,0,25.1h5.4c0-3.7,2.9-8.6,7.7-12.7 c5-4.3,11-6.9,16.1-6.9c2.3,0,4.3,0.3,6,0.8c0,0,0.1,0,0.1,0.1c4.7,2.1,7.1,5.9,8.3,9.5c0.7,2.6,1.1,5.7,1.1,9.3l5.4,0 c0,0,0,0,0,0h0C50.1,17.6,48.7,11.9,45.8,7.7z"
        })]
      })
    })
  });
};

var Spinner = function Spinner(_ref) {
  var isVisible = _ref.isVisible;

  var _useDisclosure = (0,index_esm/* useDisclosure */.qY)(),
      onClose = _useDisclosure.onClose;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* Modal */.u_, {
    isOpen: isVisible,
    onClose: onClose,
    isCentered: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist_index_esm/* ModalOverlay */.ZA, {
      bg: "blackAlpha.700"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(dist_index_esm/* ModalContent */.hz, {
      background: "transparent",
      alignItems: "center",
      boxShadow: "none",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "spinner-circle"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "spinner-logo",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoSpinner, {})
      })]
    })]
  });
};

/* harmony default export */ var common_Spinner = (Spinner);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/index.esm.js
var icons_dist_index_esm = __webpack_require__(3382);
// EXTERNAL MODULE: ./src/themes/index.tsx + 3 modules
var themes = __webpack_require__(37930);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterTag.tsx






var FilterTag = function FilterTag(_ref) {
  var isSelected = _ref.isSelected,
      hasCloseButton = _ref.hasCloseButton,
      label = _ref.label,
      onClick = _ref.onClick;

  var _useState = (0,react.useState)(false),
      isMounted = _useState[0],
      setMount = _useState[1];

  (0,react.useEffect)(function () {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  var bgColor = isSelected ? themes/* theme.colors.primaryGreen.300 */.r.colors.primaryGreen[300] : 'white';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
    color: themes/* theme.colors.primaryGreen.900 */.r.colors.primaryGreen[900],
    variant: "outline",
    fontFamily: "Montserrat-Medium",
    fontWeight: "normal",
    size: "xs",
    h: "32px",
    mr: 1,
    my: 1,
    borderRadius: 4,
    bg: bgColor,
    _hover: {
      backgroundColor: bgColor
    },
    borderColor: themes/* theme.colors.primaryGreen.300 */.r.colors.primaryGreen[300],
    userSelect: "none",
    onClick: onClick,
    rightIcon: hasCloseButton ? /*#__PURE__*/(0,jsx_runtime.jsx)(icons_dist_index_esm/* CloseIcon */.Tw, {
      boxSize: "0.7rem"
    }) : undefined,
    children: label
  });
};

/* harmony default export */ var Offers_FilterTag = (FilterTag);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/index.esm.js + 1 modules
var checkbox_dist_index_esm = __webpack_require__(9135);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterTagCheckbox.tsx





var FilterTagCheckbox = function FilterTagCheckbox(_ref) {
  var isChecked = _ref.isChecked,
      label = _ref.label,
      onChange = _ref.onChange;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
    fontFamily: "Montserrat-Medium",
    color: "baseDark",
    borderColor: themes/* theme.colors.primaryGreen.900 */.r.colors.primaryGreen[900],
    colorScheme: "primaryGreenCheckboxFilter",
    isChecked: isChecked,
    display: "block",
    size: "lg",
    lineHeight: "1.2",
    mb: "s",
    className: "filterCheck",
    onChange: onChange,
    children: label
  });
};

/* harmony default export */ var Offers_FilterTagCheckbox = (FilterTagCheckbox);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterTagImage.tsx







var FilterTagImage = function FilterTagImage(_ref) {
  var isSelected = _ref.isSelected,
      label = _ref.label,
      icon = _ref.icon,
      iconAlt = _ref.iconAlt,
      onClick = _ref.onClick,
      isMobile = _ref.isMobile;
  var borderColor = isSelected ? "".concat(themes/* theme.colors.green.600 */.r.colors.green[600], ", 0 2px 8px 0 rgba(44, 190, 97, 0.13)") : themes/* theme.colors.borders.grey */.r.colors.borders.grey;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(layout_dist_index_esm/* Badge */.Ct, {
    suppressHydrationWarning: true,
    as: "button",
    variant: "outline",
    p: 2,
    m: 1,
    h: isMobile ? '4.563rem' : '4.688rem',
    w: isMobile ? '5.625rem' : '',
    borderRadius: 4,
    textTransform: "none",
    boxShadow: "inset 0 0 0px 1px ".concat(borderColor),
    color: "baseNeutral.700",
    onClick: onClick,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: icon,
      alt: iconAlt,
      width: "40",
      height: "40"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: label
    })]
  });
};

/* harmony default export */ var Offers_FilterTagImage = (FilterTagImage);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/switch/dist/index.esm.js
var switch_dist_index_esm = __webpack_require__(68185);
;// CONCATENATED MODULE: ./src/components/common/Offers/FilterSwitch.tsx






var FilterSwitch = function FilterSwitch(_ref) {
  var title = _ref.title,
      label = _ref.label,
      isSelected = _ref.isSelected,
      onChange = _ref.onChange;

  var _useState = (0,react.useState)(isSelected),
      checked = _useState[0],
      setChecked = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isMounted = _useState2[0],
      setMount = _useState2[1];

  (0,react.useEffect)(function () {
    setChecked(isSelected);
  }, [isSelected]);
  (0,react.useEffect)(function () {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  var onSwitchChange = function onSwitchChange(evt) {
    var value = evt.target.value;
    setChecked(value === '1');
    onChange(evt);
    return value === '1';
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
      flex: "1",
      textAlign: "left",
      textTransform: "uppercase",
      fontFamily: "Montserrat-SemiBold",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
      as: "span",
      fontFamily: "Montserrat-Medium",
      fontSize: "0.875rem",
      color: "#656b72",
      children: label
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(switch_dist_index_esm/* Switch */.r, {
      colorScheme: "green",
      isChecked: checked,
      float: "right",
      value: "1",
      onChange: onSwitchChange
    })]
  });
};

/* harmony default export */ var Offers_FilterSwitch = (FilterSwitch);
;// CONCATENATED MODULE: ./src/components/common/Spaces/xs.tsx



var StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xs__StyledSpace",
  componentId: "sc-jsscb1-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xs;
});

var SpaceXS = function SpaceXS() {
  return /*#__PURE__*/_jsx(StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xs = ((/* unused pure expression or super */ null && (SpaceXS)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/l.tsx



var l_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "l__StyledSpace",
  componentId: "sc-1jip8x3-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_l;
});

var SpaceL = function SpaceL() {
  return /*#__PURE__*/_jsx(l_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var l = ((/* unused pure expression or super */ null && (SpaceL)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl.tsx



var xxl_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl__StyledSpace",
  componentId: "sc-k5154a-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xxl;
});

var SpaceXXL = function SpaceXXL() {
  return /*#__PURE__*/_jsx(xxl_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xxl = ((/* unused pure expression or super */ null && (SpaceXXL)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl_4.tsx



var xxl_4_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl_4__StyledSpace",
  componentId: "sc-1fuyqpr-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xxl_4;
});

var SpaceXXL4 = function SpaceXXL4() {
  return /*#__PURE__*/_jsx(xxl_4_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xxl_4 = ((/* unused pure expression or super */ null && (SpaceXXL4)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl_5.tsx



var xxl_5_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl_5__StyledSpace",
  componentId: "sc-16fb0l1-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xxl_5;
});

var SpaceXXL5 = function SpaceXXL5() {
  return /*#__PURE__*/_jsx(xxl_5_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xxl_5 = ((/* unused pure expression or super */ null && (SpaceXXL5)));
;// CONCATENATED MODULE: ./src/components/common/Spaces/xxl_6.tsx



var xxl_6_StyledSpace = styled_components_browser_esm["default"].span.withConfig({
  displayName: "xxl_6__StyledSpace",
  componentId: "sc-8dq84s-0"
})(["display:block;height:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.spaces.spacing_xxl_6;
});

var SpaceXXL6 = function SpaceXXL6() {
  return /*#__PURE__*/_jsx(xxl_6_StyledSpace, {
    children: ''
  });
};

/* harmony default export */ var xxl_6 = ((/* unused pure expression or super */ null && (SpaceXXL6)));
;// CONCATENATED MODULE: ./src/components/common/index.tsx
//TODO move to uikit















/***/ }),

/***/ 4848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ useBackButton; },
/* harmony export */   "rS": function() { return /* binding */ useTracking; }
/* harmony export */ });
/* unused harmony export useQuerystringToFilterOffers */
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70461);
/* harmony import */ var query_string_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31086);
/* harmony import */ var query_string_manager__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(query_string_manager__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_redux_nlt_offer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4524);
/* harmony import */ var src_redux_sell_offer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7232);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var useQuerystringToFilterOffers = function useQuerystringToFilterOffers(domain) {
  var dispatch = useDispatch();
  var performSearchOffers = domain === 'nlt' ? nltPerformSearchOffers : sellPerformSearchOffers;
  useEffect(function () {
    var qs = queryStringManager.read().get();

    if (Object.entries(qs).length > 0) {
      dispatch(performSearchOffers());
    }
  }, []);
};
var useBackButton = function useBackButton() {
  var onPopState = function onPopState() {
    if (query_string_manager__WEBPACK_IMPORTED_MODULE_4___default().read().get()) {
      location.reload();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    window.addEventListener('popstate', onPopState);
    return function () {
      window.removeEventListener('popstate', onPopState);
    };
  });
};
var useTracking = function useTracking() {
  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(),
      query = _useRouter.query;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      validQuery = _useState[0],
      setValidQuery = _useState[1];

  var _useCookies = (0,react_cookie__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(['CP_TRACKER']),
      _useCookies2 = (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_useCookies, 3),
      allCookies = _useCookies2[0],
      setCookie = _useCookies2[1],
      removeCookie = _useCookies2[2];

  var path = '/';
  var today = new Date();
  var validity = parseInt("15");
  var expires = new Date(today.setDate(today.getDate() + validity));
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setValidQuery(query);
  }, [query]);

  var trackingData = function trackingData() {
    return allCookies['CP_TRACKER'];
  };

  var setTracking = function setTracking() {
    var _query$validQuery = _objectSpread(_objectSpread({}, query), validQuery),
        _query$validQuery$utm = _query$validQuery.utm_source,
        source = _query$validQuery$utm === void 0 ? null : _query$validQuery$utm,
        _query$validQuery$utm2 = _query$validQuery.utm_medium,
        medium = _query$validQuery$utm2 === void 0 ? null : _query$validQuery$utm2,
        _query$validQuery$utm3 = _query$validQuery.utm_ref,
        referrer = _query$validQuery$utm3 === void 0 ? null : _query$validQuery$utm3,
        _query$validQuery$utm4 = _query$validQuery.utm_campaign,
        campaign = _query$validQuery$utm4 === void 0 ? null : _query$validQuery$utm4,
        _query$validQuery$utm5 = _query$validQuery.utm_campaign_date,
        campaign_date = _query$validQuery$utm5 === void 0 ? null : _query$validQuery$utm5;

    if ((source || medium || referrer) && (typeof allCookies['CP_TRACKER'] === 'undefined' || !allCookies['CP_TRACKER'])) {
      setCookie('CP_TRACKER', {
        source: source,
        referrer: referrer,
        medium: medium,
        campaign: campaign,
        campaign_date: campaign_date
      }, {
        path: path,
        expires: expires
      });
    }
  };

  var removeTracking = function removeTracking() {
    return removeCookie('CP_TRACKER');
  };

  return [setTracking, removeTracking, trackingData];
};

/***/ }),

/***/ 70461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCookies; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/utils.js

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return cookie.parse(cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/Cookies.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = cookie.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = cookie.serialize(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ var es6_Cookies = (Cookies);

;// CONCATENATED MODULE: ./node_modules/universal-cookie/es6/index.js

/* harmony default export */ var es6 = (es6_Cookies);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/Cookies.js

/* harmony default export */ var react_cookie_es6_Cookies = (es6);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/CookiesContext.js


var CookiesContext = react.createContext(new react_cookie_es6_Cookies());
var Provider = CookiesContext.Provider, Consumer = CookiesContext.Consumer;
/* harmony default export */ var es6_CookiesContext = (CookiesContext);

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/utils.js
function isInBrowser() {
    return (typeof window !== 'undefined' &&
        typeof window.document !== 'undefined' &&
        typeof window.document.createElement !== 'undefined');
}

;// CONCATENATED MODULE: ./node_modules/react-cookie/es6/useCookies.js



function useCookies(dependencies) {
    var cookies = (0,react.useContext)(es6_CookiesContext);
    if (!cookies) {
        throw new Error('Missing <CookiesProvider>');
    }
    var initialCookies = cookies.getAll();
    var _a = (0,react.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0,react.useRef)(allCookies);
    if (isInBrowser()) {
        (0,react.useLayoutEffect)(function () {
            function onChange() {
                var newCookies = cookies.getAll();
                if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
                    setCookies(newCookies);
                }
                previousCookiesRef.current = newCookies;
            }
            cookies.addChangeListener(onChange);
            return function () {
                cookies.removeChangeListener(onChange);
            };
        }, [cookies]);
    }
    var setCookie = (0,react.useMemo)(function () { return cookies.set.bind(cookies); }, [cookies]);
    var removeCookie = (0,react.useMemo)(function () { return cookies.remove.bind(cookies); }, [cookies]);
    return [allCookies, setCookie, removeCookie];
}
function shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) {
        return true;
    }
    for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) {
            return true;
        }
    }
    return false;
}


/***/ }),

/***/ 11669:
/***/ (function(module) {

module.exports = JSON.parse('[{"href":"alfa-romeo","image":"https://static1.carplanner.com/cars/brands/alfa-romeo.svg","name":"Alfa Romeo","slug":"ALF"},{"href":"abarth","image":"https://static1.carplanner.com/cars/brands/abarth.svg","name":"Abarth","slug":"ABA"},{"href":"aston-martin","image":"https://static1.carplanner.com/cars/brands/aston-martin.svg","name":"Aston Martin","slug":"AST"},{"href":"audi","image":"https://static1.carplanner.com/cars/brands/audi.svg","name":"Audi","slug":"AUD"},{"href":"bentley","image":"https://static1.carplanner.com/cars/brands/bentley.svg","name":"Bentley","slug":"BEN"},{"href":"bmw","image":"https://static1.carplanner.com/cars/brands/bmw.svg","name":"BMW","slug":"BMW"},{"href":"cadillac","image":"https://static1.carplanner.com/cars/brands/cadillac.svg","name":"Cadillac","slug":"CAD"},{"href":"chevrolet","image":"https://static1.carplanner.com/cars/brands/chevrolet.svg","name":"Chevrolet","slug":"CHC"},{"href":"chrysler","image":"https://static1.carplanner.com/cars/brands/chrysler.svg","name":"Chrysler","slug":"CHR"},{"href":"citroen","image":"https://static1.carplanner.com/cars/brands/citroen.svg","name":"Citroen","slug":"CIT"},{"href":"cupra","image":"https://static1.carplanner.com/cars/brands/cupra.svg","name":"Cupra","slug":"CUP"},{"href":"dacia","image":"https://static1.carplanner.com/cars/brands/dacia.svg","name":"Dacia","slug":"DAC"},{"href":"dr","image":"https://static1.carplanner.com/cars/brands/dr.svg","name":"DR","slug":"DRM"},{"href":"ds","image":"https://static1.carplanner.com/cars/brands/ds.svg","name":"DS","slug":"DSA"},{"href":"ferrari","image":"https://static1.carplanner.com/cars/brands/ferrari.svg","name":"Ferrari","slug":"FER"},{"href":"fiat","image":"https://static1.carplanner.com/cars/brands/fiat.svg","name":"Fiat","slug":"FIA"},{"href":"ford","image":"https://static1.carplanner.com/cars/brands/ford.svg","name":"Ford","slug":"FOR"},{"href":"honda","image":"https://static1.carplanner.com/cars/brands/honda.svg","name":"Honda","slug":"HON"},{"href":"hyundai","image":"https://static1.carplanner.com/cars/brands/hyundai.svg","name":"Hyundai","slug":"HYU"},{"href":"infiniti","image":"https://static1.carplanner.com/cars/brands/infiniti.svg","name":"Infiniti","slug":"INF"},{"href":"jaguar","image":"https://static1.carplanner.com/cars/brands/jaguar.svg","name":"Jaguar","slug":"JAG"},{"href":"jeep","image":"https://static1.carplanner.com/cars/brands/jeep.svg","name":"Jeep","slug":"JEE"},{"href":"kia","image":"https://static1.carplanner.com/cars/brands/kia.svg","name":"Kia","slug":"KIA"},{"href":"lamborghini","image":"https://static1.carplanner.com/cars/brands/lamborghini.svg","name":"Lamborghini","slug":"LAM"},{"href":"lancia","image":"https://static1.carplanner.com/cars/brands/lancia.svg","name":"Lancia","slug":"LAN"},{"href":"land-rover","image":"https://static1.carplanner.com/cars/brands/land-rover.svg","name":"Land Rover","slug":"LND"},{"href":"lexus","image":"https://static1.carplanner.com/cars/brands/lexus.svg","name":"Lexus","slug":"LEX"},{"href":"lotus","image":"https://static1.carplanner.com/cars/brands/lotus.svg","name":"Lotus","slug":"LOT"},{"href":"mahindra","image":"https://static1.carplanner.com/cars/brands/mahindra.svg","name":"Mahindra","slug":"MAH"},{"href":"maserati","image":"https://static1.carplanner.com/cars/brands/maserati.svg","name":"Maserati","slug":"MAS"},{"href":"mazda","image":"https://static1.carplanner.com/cars/brands/mazda.svg","name":"Mazda","slug":"MAZ"},{"href":"mclaren","image":"https://static1.carplanner.com/cars/brands/mclaren.svg","name":"McLaren","slug":"MCL"},{"href":"mercedes","image":"https://static1.carplanner.com/cars/brands/mercedes.svg","name":"Mercedes-Benz","slug":"MER"},{"href":"mg","image":"https://static1.carplanner.com/cars/brands/mg.svg","name":"MG","slug":"MGG"},{"href":"mini","image":"https://static1.carplanner.com/cars/brands/mini.svg","name":"Mini","slug":"MIN"},{"href":"mitsubishi","image":"https://static1.carplanner.com/cars/brands/mitsubishi.svg","name":"Mitsubishi","slug":"MIT"},{"href":"nissan","image":"https://static1.carplanner.com/cars/brands/nissan.svg","name":"Nissan","slug":"NIS"},{"href":"opel","image":"https://static1.carplanner.com/cars/brands/opel.svg","name":"Opel","slug":"OPE"},{"href":"peugeot","image":"https://static1.carplanner.com/cars/brands/peugeot.svg","name":"Peugeot","slug":"PEU"},{"href":"porsche","image":"https://static1.carplanner.com/cars/brands/porsche.svg","name":"Porsche","slug":"POR"},{"href":"renault","image":"https://static1.carplanner.com/cars/brands/renault.svg","name":"Renault","slug":"REN"},{"href":"rolls-royce","image":"https://static1.carplanner.com/cars/brands/rolls-royce.svg","name":"Rolls-Royce","slug":"ROL"},{"href":"seat","image":"https://static1.carplanner.com/cars/brands/seat.svg","name":"Seat","slug":"SEA"},{"href":"skoda","image":"https://static1.carplanner.com/cars/brands/skoda.svg","name":"Skoda","slug":"SKO"},{"href":"smart","image":"https://static1.carplanner.com/cars/brands/smart.svg","name":"Smart","slug":"SMA"},{"href":"ssangyong","image":"https://static1.carplanner.com/cars/brands/ssangyong.svg","name":"Ssangyong","slug":"SAN"},{"href":"subaru","image":"https://static1.carplanner.com/cars/brands/subaru.svg","name":"Subaru","slug":"SUB"},{"href":"suzuki","image":"https://static1.carplanner.com/cars/brands/suzuki.svg","name":"Suzuki","slug":"SUZ"},{"href":"tesla","image":"https://static1.carplanner.com/cars/brands/tesla.svg","name":"Tesla","slug":"TES"},{"href":"toyota","image":"https://static1.carplanner.com/cars/brands/toyota.svg","name":"Toyota","slug":"TOY"},{"href":"volkswagen","image":"https://static1.carplanner.com/cars/brands/volkswagen.svg","name":"Volkswagen","slug":"VLK"},{"href":"volvo","image":"https://static1.carplanner.com/cars/brands/volvo.svg","name":"Volvo","slug":"VOL"}]');

/***/ }),

/***/ 34755:
/***/ (function(module) {

module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Scopri tutte le offerte di Noleggio a Lungo Termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Scopri tutte le offerte di Auto in Vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

}]);